import * as React from 'react';
import * as Session from '../../service/Session';
import * as DTO from '../../service/DTOs';

export const batchSize: number = 15;

export const CHAT_STATUS_ONLINE = 'Online';
export const CHAT_STATUS_OFFLINE = 'Offline';
export const CHAT_STATUS_AWAY = 'Away';

export interface ChatTextMessage extends DTO.AgentTextMessage {
    liElem: HTMLLIElement | null;
    seen?: boolean;
}

//export interface ChatUserState {
//    personalState: Session.PersonalState;
//    connectStatus: 'Online' | 'Offline' | 'Away';
//}

//export interface ChatState {
//    IdChat?: number;
//    title?: string;
//    privatechatuser?: ChatUserState;
//}
